<template>
  <div
    class="db f6 br-pill ph3 ba bw1 pv2 dib ma1"
    :class="{
      'b--purple purple': brand === 'lh',
      'b--dark-gray dark-gray': brand === 'lq'
    }"
    @click="$emit('click')"
  >
    <div class="flex items-center">
      <simple-svg
        v-if="icon"
        :filepath="icon"
        style="width: 1.5rem; height: 1.5rem"
        class="dib mr2"
        :class="{
          'purple': brand === 'lh',
          'dark-gray': brand === 'lq'
        }"
      />
      <div
        class="dib b"
        v-if="text"
        v-html="text"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Button',
  props: {
    brand: {
      type: String,
      default: 'lh'
    },
    text: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    }
  }
}
</script>
